/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @param {Object} parse - Object for property resolution.
 */
const propLookupFactory = $parse => {
    return (path, scope) => {
        return $parse(path)(scope);
    };
};

propLookupFactory.$inject = [
    '$parse',
];

angular.module('avi/utils').factory('propLookup', propLookupFactory);
